import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from '@astek/utils';
import {PressureUnitEnum} from '../services/state/pressure-unit.enum';

@Pipe({
  name: 'xpPressureUnitKey',
})
export class PressureUnitKeyPipe implements PipeTransform {

  constructor() {
  }

  public transform(value: PressureUnitEnum | string | null | undefined): string {
    if (
      Utils.isNullOrUndefined(value)
      || (Utils.isString(value) && !Utils.enumValueExists(value, PressureUnitEnum))
    ) {
      return 'SHARED.EMPTY_VALUE';
    }
    return 'SHARED.PRESSURE_UNIT.' + Utils.enumName(value, PressureUnitEnum);
  }

}
